// «Что входит в услугу»: список коротких пунктов на всех языках сайта.
// value — массив вида [{ en, ru, kk }, ...], onChange(newArray).
const LANGS = [
  { code: "ru", label: "Русский" },
  { code: "en", label: "English" },
  { code: "kk", label: "Қазақша" },
];

const INPUT_CLS =
  "w-full rounded-md border-0 py-1.5 px-3 text-neutral-900 ring-1 ring-inset ring-neutral-300 placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm";

export default function FeaturesInput({ value = [], onChange }) {
  const setAt = (index, lang, text) =>
    onChange(
      value.map((item, i) => (i === index ? { ...item, [lang]: text } : item))
    );

  const add = () => onChange([...value, { ru: "", en: "", kk: "" }]);
  const removeAt = (index) => onChange(value.filter((_, i) => i !== index));

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1">
        <div className="block text-base font-medium text-neutral-700">
          Что входит {value.length > 0 ? `(${value.length})` : ""}
        </div>
        <button
          type="button"
          onClick={add}
          className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md shadow-sm text-white bg-sky-600 hover:bg-sky-500"
        >
          Добавить пункт
        </button>
      </div>
      <p className="text-sm text-neutral-500 mb-3">
        Короткие пункты, которые клиент видит галочками в карточке услуги.
      </p>

      {value.length === 0 ? (
        <div className="text-sm text-neutral-400 border border-dashed border-neutral-300 rounded-lg py-6 text-center">
          Пунктов пока нет
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {value.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-neutral-200 p-3"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-neutral-500">{`Пункт № ${index + 1}`}</span>
                <button
                  type="button"
                  onClick={() => removeAt(index)}
                  className="text-sm text-red-600 hover:text-red-500"
                >
                  Удалить
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                {LANGS.map((l) => (
                  <div key={l.code}>
                    <span className="block text-xs text-neutral-400 mb-0.5">
                      {l.label}
                    </span>
                    <input
                      type="text"
                      className={INPUT_CLS}
                      value={item?.[l.code] || ""}
                      onChange={(e) => setAt(index, l.code, e.target.value)}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
